import React from "react"
import ErrorBoundary from "./src/components/ErrorBoundary"
import { trackPageView, setupLinkClickTracking } from "./src/utils/metaPixel"
import { persistUtmParams } from "./src/utils/utmParams"

import "./src/styles/global.css"
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"

let isInitialRouteUpdate = true

export const wrapRootElement = ({ element }) => {
  return <ErrorBoundary>{element}</ErrorBoundary>
}

export const onClientEntry = () => {
  setupLinkClickTracking()
  persistUtmParams(window.location)
}

export const onRouteUpdate = ({ location }) => {
  persistUtmParams(location)

  // The base Meta Pixel script in gatsby-ssr.js already fires a PageView on
  // initial load. Skip the first onRouteUpdate so we don't double-count it.
  if (isInitialRouteUpdate) {
    isInitialRouteUpdate = false
    return
  }

  trackPageView()
}
